export interface RuntimeConfig {
  REACT_APP_DD_APP_ID: string
  REACT_APP_DD_CLIENT_TOKEN: string
  REACT_APP_DD_ENV: string
  REACT_APP_DD_LOGS_ENABLED: string
  REACT_APP_DD_SERVICE: string
  REACT_APP_DD_SITE: string
  REACT_APP_DD_TRACE_ENABLED: string
  REACT_APP_DD_VERSION: string
  REACT_APP_DD_ALLOW_TRACE_URL: string
  REACT_APP_DD_SESSION_RATE: string
  REACT_APP_DD_SESSION_REPLAY_RATE: string
  REACT_APP_DD_TRACK_RESOURCE: string
  REACT_APP_DD_TRACK_LONG_TASK: string
  REACT_APP_DD_USER_INTERACTION: string
  REACT_APP_DD_TRACE_SAMPLE_RATE: string
  EXTEND_ESLINT: string
  REACT_APP_BASEURL: string
  REACT_APP_FILES_BASEURL: string
  FAST_REFRESH: string
  REACT_APP_INSIGHTS_CONNECTION_STRING: string
  REACT_APP_COPILOT_TOKEN_URL: string
  SKIP_PREFLIGHT_CHECK: string
  NODE_ENV: string
  PUBLIC_URL: string
}

let _config: RuntimeConfig | null = null

export async function loadRuntimeConfig(): Promise<RuntimeConfig> {
  const response = await fetch("/config.json")
  if (!response.ok) {
    throw new Error(`Failed to load runtime config: ${response.statusText}`)
  }
  _config = await response.json()
  return _config!
}

export function getRuntimeConfig(): RuntimeConfig {
  if (!_config) {
    throw new Error(
      "Runtime config not loaded. Call loadRuntimeConfig() first."
    )
  }
  return _config
}

// Test-only synchronous setter: lets jest-setup.ts populate the runtime
// config before any module-level code (e.g. config.baseURL getters
// evaluated at import time) runs, since fetch-based loadRuntimeConfig() is
// async and would resolve too late for static imports.
export function setRuntimeConfigForTests(cfg: RuntimeConfig): void {
  _config = cfg
}
